import React from 'react'
import BaseIcon from './BaseIcon'
import img from 'assets/img/ic-check-default.png'

const CheckedIconDefault = (props: any) => {
  return (
    <BaseIcon
      img={img}
      onClick={props.onClick}
      size={props.size}
      disabled={props.disabled}
    />
  )
}

export default CheckedIconDefault
